module.exports = __webpack_public_path__ + "img/DE00885.d41563bb.png";